import React from 'react';

interface SafeTextRendererProps {
  text: string;
  className?: string;
}

export function SafeTextRenderer({ text, className }: SafeTextRendererProps) {
  const renderTextWithHighlights = React.useMemo(() => {
    if (!text || typeof text !== 'string') {
      return null;
    }

    // Split the text by <em> tags while preserving the tags
    const parts = text.split(/(<em>.*?<\/em>)/g);

    return parts
      .map((part, index) => {
        // Check if this part is an <em> tag
        const emMatch = part.match(/^<em>(.*?)<\/em>$/);

        if (emMatch) {
          // This is highlighted text - render as <em> element
          const content = emMatch[1];
          return content ? <em key={index}>{content}</em> : null;
        } else if (part) {
          // This is regular text - render as string (only if not empty)
          return part;
        }
        return null;
      })
      .filter(Boolean); // Remove empty/null parts
  }, [text]);

  if (!renderTextWithHighlights || renderTextWithHighlights.length === 0) {
    // Fallback to rendering the original text if no highlights are found
    return <span className={className}>{text}</span>;
  }

  return <span className={className}>{renderTextWithHighlights}</span>;
}

SafeTextRenderer.displayName = 'SafeTextRenderer';
